import { srCommonTranslates } from '@g2-shared/common';

export const srb = {
  woops: 'Ups! Došlo je do greške...',
  welcome: 'Dobro došli!',
  continue: 'Nastavi',
  saveChanges: 'Sačuvaj promene',
  apply: 'Primeni',
  sendMoney: 'Slanje novca',
  trackTransaction: 'Pratite transakciju',
  menu: 'Meni',
  findLocation: 'Pronađi lokaciju',
  findLocationForVerification: 'Posetite Western Union lokaciju',
  customerSupport: 'Korisnička podrška',
  history: 'Istorija',
  profile: 'Profil',
  logout: 'Odjavite se',
  login: 'Prijavite se',
  successLogout: 'Uspešna odjava',
  hello: 'Zdravo',
  homeHelloText: 'Sva važna upozorenja i obaveštenja ćete videti ovde.',
  transactionHistory: 'Istorija transakcija',
  latestTransactions: 'Poslednje transakcije',
  description: 'Opis',
  mtcn: 'MTCN',
  date: 'Datum',
  amount: 'Iznos',
  status: 'Status',
  maxAmountTitle: 'Maksimalni iznosi koji se mogu poslati',
  byTransaction: 'Po transakciji',
  byDay: 'Po danu',
  byMonth: 'Po mesecu',
  en: 'Engleski',
  srb: 'Srpski',
  idCard: 'Lična karta',
  passport: 'Pasoš',
  refugee_id: 'Izbeglička legitimacija',
  asylumSeekerId: 'Azilantska lična karta',
  diplomaticId: 'Diplomatska lična karta',
  emergencyTravelDocument: 'Putni list',
  militaryIdentificationCard: 'Vojna knjižica',
  convictIdentificationCard: 'Osuđenička legitimacija',
  foreignId: 'Strana lična karta',
  idForeignCitizen: 'Lična karta za strance',
  drivingLicence: 'Vozačka dozvola',
  successConfirmedVerifyPhoneCode: 'Uspešno potvrđen kod za verifikaciju broja telefona.',
  successSentPhoneVerifyCode: 'Uspešno poslat kod za verifikaciju telefona.',
  agreeWith: 'Saglasan/na sam sa',
  acceptTermsAndConditionsLinkText:
    'Western Union uslovima kreiranja profila i online izjavom poverljivosti.',
  acceptNewsletter:
    'Informišite me o novim uslovima Western Uniona i drugim specijalnim ponudama. Komunikacija može biti SMS-om, emailom, telefonom i poštom. Ovo možete promeniti u postavkama Vašeg profila u bilo kom trenutku.',

  // Profile
  profileManagement: 'Upravljanje profilom',
  saveUserDetails: 'Sačuvaj korisničke podatke',
  notification: 'Obaveštenje',
  registrationProcessingText:
    'Uspešno ste izvršili kreiranje korisničkog naloga. Kako biste mogli da koristite Western Union online uslugu, neophodno je da potvrdite svoj identitet:',
  connectToVideoIdentification: 'Korišćenjem usluge video identifikacije,',
  or: 'ili',
  visitOneOfTenforeLocations: 'Posetite jednu od Tenfore lokcija za potvrdu identiteta.',

  // Profile tabs
  personalInfo: 'Lične informacije',
  userData: 'Podaci o korisniku',
  securityIssue: 'Sigurnosno pitanje',
  password: 'Lozinka',

  // User personal details
  birthDate: 'Datum rođenja',
  birthPlace: 'Mesto rođenja',
  birthCountry: 'Zemlja rođenja',
  country: 'Zemlja',
  documentType: 'Vrsta dokumenta',
  documentIssuer: 'Izdavalac lične isprave',
  documentNumber: 'Broj dokumenta',
  documentDateOfIssue: 'Datum izdavanja isprave',
  documentExpirationDate: 'Datum isteka dokumenta',
  noExpirationDate: 'Trajno važenje dokumenta',
  successUpdatedUserPersonalDetails: 'Uspešno ažurirane lične informacije',
  comment: 'Komentar',
  state: 'State',
  documentCountryOfIssue: 'Država izdavanja dokumenta',

  // User details
  address1: 'Adresa 1',
  address2: 'Adresa 2',
  phone: 'Telefon',
  mobile: 'Mobilni telefon',
  successUpdatedUserDetails: 'Uspešno ažurirani podaci o korisniku',
  verified: 'Verifikovan',
  register: 'Registracija',
  alreadyHaveAccount: 'Već imate nalog?',
  passwordIsNotValid: 'Lozinke se ne poklapaju',
  successRegisteredUser: 'Uspešna registracija korisnika',
  successResendEmailVerify: 'Uspešno poslata verifikacija',
  pleaseCheckMessages: 'Proverite svoje poruke!',
  sendCodeText: 'Poslali smo Vam šestocifreni kod na broj ',
  secondSendCodeText:
    '. Molimo Vas unesite kod u polja ispod kako biste verifikovali Vaš broj telefona.',
  didntGetVerifySms: 'Niste dobili verifikacioni kod?',
  resendVerify: 'Ponovite slanje',
  backToLogin: 'Nazad',
  completeRegister: 'Kompletiraj registraciju',
  completedRegister: 'Uspešno kreiran korisnički nalog.',
  agreeWithWesternUnion: 'Saglasan/na sam sa Western Union ',
  termsOfCreateProfile: 'uslovima kreiranja profila',
  and: ' i ',
  onlineStatementConfidentiality: 'online izjavom o poverljivosti',
  registerSubscribeText:
    'Informišite me o novim uslovima Western Uniona i drugim specijalnim ponudama. Komunikacija može biti SMS-om, emailom, telefonom i poštom. Ovo možete promeniti u postavkama Vašeg profila u bilo kom trenutku.',
  dateMustBeInFeature: 'Datum mora biti u budućnosti.',

  // Security issue
  replySecurityIssue: 'Odogovor na sigurnosno pitanje',
  successUpdatedUserSecurityIssue: 'Uspešno ažurirano sigurnosno pitanje',

  // Password
  currentPassword: 'Trenutna lozinka',
  newPassword: 'Nova lozinka',
  confirmationNewPassword: 'Potvrdite lozinku',
  passwordRules:
    'Lozinka mora sadržati 8-16 karaktera, jedno malo slovo, jedno veliko slovo, jedan broj, jedan specijalni karakter.',
  successUpdatedUserPassword: 'Uspešno ažurirana lozinka',

  // Send money
  sendMoneyTo: 'Slanje novca u',
  payoutAmount: 'Iznos za prijem',
  paymentAmount: 'Iznos za slanje',
  howDeliveryMoney: 'Kako Vaš primalac želi da primi novac?',
  howYouWantToPay: 'Kako biste želeli da platite?',
  payoutOnLocation: 'Isplata na WU lokaciji',
  creditDebitCard: 'Kreditna/Debitna kartica',
  next: 'Nastavite',
  step: 'Korak',
  here: 'ovde',

  // Receiver
  receiverInfo: 'Podaci o primaocu',
  noEnteredReceivers: 'Nemate unetih primaoca',
  successCreatedTransactionReceiver: 'Uspešno kreiran primalac',
  successDeletedTransactionReceiver: 'Uspešno obrisan primalac',
  deleteReceiver: 'Obriši primaoca',
  addNewReceiver: 'Dodaj novog primaoca',
  transactionPurpose: 'Svrha plaćanja',
  residence: 'Prebivalište',
  cancel: 'Odustani',

  // Summary card
  summary: 'Rezime',
  noDataToDisplay: 'Nema podataka za prikaz',
  yes: 'Da',
  no: 'Ne',
  transactionAmount: 'Iznos transakcije',
  wuFee: 'Naknada WU transfera',
  promoCode: 'Promo kod',
  total: 'Ukupno',
  canImmediatePayout: 'Novac je dostupan odmah',
  amountForPayout: 'Iznos za isplatu',
  successAppliedPromoCode: 'Uspešno primenjen promo kod',
  moneyReceivedAs: 'Način isplate',
  paidWith: 'Način uplate',
  exchangeRate: 'Kurs',

  // Disclaimer and liability
  disclaimerTitle: 'Odricanje odgovornosti i važne informacije',

  // Card
  cardNumber: 'Broj kartice',
  expiryMonth: 'Mesec',
  expiryYear: 'Godina',
  cvc: 'Zaštitni kod',
  helperTextCvc: '4 ili 3 cifre na poleđini Vaše kartice',
  addNewCard: 'Dodaj novu karticu',
  paymentInformation: 'Informacije o plaćanju',
  noEnteredCards: 'Nemate unetih kartica',
  successCreatedCard: 'Uspešno dodata kartica',
  successDeletedCard: 'Uspešno obrisana kartica',
  deleteCard: 'Obriši karticu',
  weAccept: 'Prihvatamo',

  // Transaction
  successCreatedTransaction: 'Uspešno kreirana transakcija',
  back: 'Nazad',
  transactionId: 'ID Transakcije',
  transactionDetails: 'Detalji transakcije',
  details: 'Detalji',
  withdrawalInformation: 'Informacije za podizanje novca',
  sender: 'Pošiljalac',
  sentFrom: 'Poslato iz',
  dateAndTime: 'Datum i vreme',
  receiver: 'Primalac',
  payoutType: 'Način isplate',
  paymentType: 'Način plaćanja',
  paymentWithCard: 'Kartica',
  transactionRate: 'Kurs',
  downloadConfirmation: 'Preuzmi potvrdu',
  repeatTransaction: 'Ponovi transakciju',
  sendNewTransaction: 'Pošalji novu transakciju',
  backToHomeScreen: 'Nazad na početni ekran',
  visitWesternUnionLocation: 'Posetite Western Union lokaciju.',
  findLocationCloseToYou: 'Pronađite lokaciju ',
  tellTheAgent: 'Recite operateru da želite da podignete transakciju koja Vam je poslata',
  mtcnIs: 'i saopštite referentni broj/MTCN',
  provideIssuedId:
    'Moguće je da će Vam biti potreban lični dokument kako bi Vas operater identifikovao.',
  copiedMtcn: 'Kopiran MTCN.',
  noTransactions: 'Nemate transakcija',
  completeTransaction: 'Završite transakciju?',
  checkDataText: 'Molimo Vas da proverite da li su svi podaci ispravno uneti.',
  sendMoneyNow: 'Pošaljite novac',
  dateFrom: 'Datum od',
  dateTo: 'Datum do',
  sendTransaction: 'Pošaljite transakciju',
  backToPreviousStep: 'Nazad na prethodni korak',
  newCard: 'Nova kartica',
  currency: 'Valuta',
  acceptTermsText: 'Saglasan/na sam sa ',
  acceptTermsTextLink: 'uslovima pružanja usluge.',
  termsText1:
    'Sredstva mogu biti zadržana ili usluga moze biti nedostupna zbog određenih uslova koji uključuju iznos koji je poslat, zemlju odredišta, raspoloživost valute, regulatorna pitanja, zahteve za identifikacijom, razlike u vremenskim zonama, radnog vremena lokacija, vreme isplate ili opcije odložene isplate. Dodatne restrikcije su moguće, a za detalje pogledajte Uslovi digitalne novcane doznake.',
  termsText2:
    'Pored zarada kroz naplatu naknada za vršenje usluga online novčanih doznaka, Western Union i Partneri zarađuju i konverzijom novca. Kada unesete iznos i nacin slanja novca, pažljivo pogledajte naknade i uplatni kurs. Naknade i kurs zavise od više faktora, uključujući brend, nacin slanja i isplate. Naknade i kurs se mogu promeniti bez prethodnog obaveštenja. Transakcije podležu lokalnim poreskim propisima. Prenos novca u Liban podleže plaćanju troškova obrade u iznosu od 2 %, koji se naplaćuju od glavnog iznosa tokom isplate u američkim dolarima na lokaciji na kojoj posluje agent.',
  termsLinkText: 'Uslovi digitalne novčane doznake.',
  successfullyTransaction: 'Transakcija je uspešna!',
  successfullyTransactionText:
    'Uspešno ste poslali novac. Da bi primalac mogao da podigne novac, pratite upustva ispod.',
  fixedText: 'Primalac ce dobiti naznacen iznos',
  failedTransaction: 'Transakcija je neuspešna!',
  failedTransactionText:
    'Vaša transakcija ne može biti izvršena u ovom trenutku. Za više informacija, pozovite korisnički centar.',
  suspendedTransactionTitle: 'Transakcija je na čekanju da se odobri',
  purpose1: 'Izdržavanje porodice/Životni troškovi',
  purpose2: 'Poklon',
  purpose3: 'Plaćanje robe i usluga/Komercijalna transakcija',
  purpose4: 'Putni troškovi',
  purpose5: 'Obrazovanje/Školarina',
  purpose6: 'Iznajmljivanje nekretnine',
  purpose7: 'Hitan slučaj/Medicinski troškovi',
  purpose8: 'Dobrotvorne svrhe',
  unsuccessfullyPayment: 'Žao nam je, Vašu transakciju nismo bili u mogućnosti da naplatimo.',
  rejectedTransaction:
    'Vaša transakcija je odbijena, molimo Vas pozovite Korisnički centar na 011 333 4 999.',
  timeoutTransaction:
    'Vaša transakcije nije izvršena u predviđenom vremenu. Molimo Vas pozovite Korisnički centar na broj 011 333 4 999.',
  suspendedTransaction:
    'Vaša transakcija je na proveri, molimo Vas pozovite Korisnički centar na broj 011 333 4 999.',

  // Pages
  homePageTitle: 'Početna stranica | Western union',
  sendMoneyPageTitle: 'Slanje novca | Western union',
  historyOfTransactionsPage: `Istorija transakcija | Western union`,
  personalInfoPage: 'Lične informacije | Western union',
  userDataPage: 'Korisnički podaci | Western union',
  transactionShowPage: 'Detalji transakcije | Western union',
  completedTransactionPage: 'Izvršena transakcija | Western union',
  registerPage: 'Registracija | Western union',
  loginPage: 'Prijava | Western union',
  saveUserDetailsPage: 'Potvrda podataka | Western union',
  failedTransactionPage: 'Neuspešna transakcija | Western union',

  // Validation
  minimumAmount: 'Iznos može biti minimum ',
  maxLength: 'Maksimalna dužina polja je ',

  // Global
  applicationError: 'Došlo je do greške, molimo pokušajte kasnije.',
  loading: 'Učitavanje',
  invalidField: 'Nevalidno polje',

  // Footer
  sendMoneyWithWuOnline: 'Pošaljite novac uz WU online',
  withJustAFewClicks: 'Uz par klikova iz udobnosti vašeg doma.',
  support: 'Podrška',
  aboutUs: 'O nama',
  info: 'Info',
  pricing: 'Cenovnik',
  pricingUrl: '/docs/pricing-en.pdf',
  tf_home_link: 'https://www.tenfore.rs/pocetna',
  wu_home_link: 'https://www.westernunion.com/global/',

  footer_cta_title: 'Pošaljite novac uz WU online',
  footer_cta_subtitle: 'Uz par klikova iz udobnosti vašeg doma.',
  footer_cta: 'Pošaljite novac',
  footer_phone: 'Telefon',
  footer_support: 'Podrška',
  footer_customer_support: 'Korisnička podrška',
  footer_faq: 'Česta pitanja',
  footer_about_us: 'O nama',
  footer_about_WU: 'O Western Union',
  footer_about_tenfore: 'O Tenfore platnoj instituciji',
  footer_our_service: 'Naše usluge',
  footer_nbs_licence: 'Dozvola NBS',
  footer_info: 'Info',
  footer_send_with_WU: 'Pošaljite novac uz WUONLINE',
  footer_protection: 'Zaštita od prevare',
  footer_ways_to_send: 'Načini slanja novca',
  footer_WU_instructions: 'WUONLINE uputstvo za slanje',
  footer_registration_instructions: 'Uputstvo za registraciju',
  footer_track_transfer: 'Prati svoj transfer',
  footer_privacy_policy: 'Izjava privatnosti',
  footer_terms_of_use: 'Uslovi korišćenja',
  footer_terms_of_use_url: '/docs/terms-and-conditions-sr-2025.pdf',
  footer_new_terms_of_use: 'Uslovi korišćenja - 2026',
  footer_new_terms_of_use_url: '/docs/terms-and-conditions-sr-2026.pdf',
  footer_general_terms: 'Opšti uslovi',
  footer_general_terms_url: '/docs/general-terms-and-conditions-sr.pdf',
  footer_pricing: 'Cenovnik',
  footer_pricing_url: '/docs/pricing-sr.pdf',
  footer_data_collection: 'Obaveštenje o prikupljanju i obradi podataka o ličnosti',
  footer_data_collection_url: '/docs/notification-on-data-sr.pdf',
  footer_privacy_policy_url: 'https://www.westernunion.com/global/sr/privacy-statement.html',
  footer_protection_url:
    'https://www.tenfore.rs/za-korisnike/western-union/prevare-i-zastita-korisnika',
  footer_ways_to_send_url: 'https://www.tenfore.rs/za-korisnike/western-union#c3620',
  footer_WU_instructions_url: 'https://www.tenfore.rs/za-korisnike/western-union#c3618',
  footer_registration_instructions_url: 'https://www.tenfore.rs/za-korisnike/western-union#c3618',
  footer_customer_support_url: 'https://www.tenfore.rs/za-korisnike/kontakt',
  footer_track_transfer_url: ' https://www.westernunion.com/web/global-service/track-transfer',
  footer_faq_url: 'https://www.tenfore.rs/za-korisnike/cesta-pitanja',
  footer_about_us_url: 'https://www.tenfore.rs/o-nama/o-nama',
  footer_about_WU_url: 'https://www.tenfore.rs/o-nama/o-western-unionu ',
  footer_our_service_url: 'https://www.tenfore.rs/o-nama/usluge',
  footer_nbs_licence_url: 'https://www.tenfore.rs/o-nama/dozvola-nbs',

  complaints: 'Kontakt za prigovore',
  complaints_url: 'https://transfernovca.rs/za-korisnike/kontakt-za-prigovore',

  // Footer links
  faq: 'Česta pitanja',
  aboutWu: 'O Western Union',
  aboutTenfore: 'O Tenfore platnoj instituciji',
  aboutServices: 'Naše usluge',
  libenceNbs: 'Dozvola NBS',
  sendMoneyWithWu: 'Pošaljite novac uz WUONLINE',
  fraudProtection: 'Zaštita od prevare',
  typeOfSendMoney: 'Načini slanja novca',
  sendMoneyGuide: 'WUONLINE uputstvo za slanje',
  registrationGuide: 'Uputstvo za registraciju',
  trackOwnTransfer: 'Prati svoj transfer',
  statementPolicy: 'Izjava privatnosti',
  termsOfUse: 'Uslovi korišćenja',
  generalTerms: 'Opšti uslovi',
  noticeOnCollectionAndProcessingOfPersonalData:
    'Obaveštenje o prikupljanju i obradi podataka o ličnosti',

  customerSupportUrl: 'https://www.tenfore.rs/za-korisnike/kontakt',
  faqUrl: 'https://www.tenfore.rs/za-korisnike/cesta-pitanja',
  aboutWuUrl: 'https://www.tenfore.rs/o-nama/o-western-unionu',
  aboutTenforeUrl: 'https://www.tenfore.rs/o-nama/o-nama',
  aboutServicesUrl: 'https://www.tenfore.rs/o-nama/usluge',
  libenceNbsUrl: 'https://www.tenfore.rs/o-nama/dozvola-nbs',
  sendMoneyWithWuUrl: '/',
  fraudProtectionUrl:
    'https://www.tenfore.rs/za-korisnike/western-union/prevare-i-zastita-korisnika',
  typeOfSendMoneyUrl: 'https://www.tenfore.rs/za-korisnike/western-union#c3620',
  sendMoneyGuideUrl: 'https://www.tenfore.rs/za-korisnike/western-union#c3618',
  registrationGuideUrl: 'https://www.tenfore.rs/za-korisnike/western-union#c3618',
  statementPolicyUrl: 'https://www.westernunion.com/global/sr/privacy-statement.html',
  trackOwnTransferUrl: 'https://www.westernunion.com/web/global-service/track-transfer',

  notificationOnDataUrl: '/docs/notification-on-data-en.pdf',
  generalTermsAndConditionsUrl: '/docs/general-terms-and-conditions-en.pdf',
  termsAndConditionsUrl: '/docs/terms-and-conditions-en.pdf',
  tenforeLocationsUrl: 'https://www.tenfore.rs/lokacije?sending_online=3',

  CREATED: 'Kreirana',
  VALIDATED: 'Validirana',
  VALIDATION_FAILED: 'Neuspešna validacija',
  PASSED_AML: 'Prošao AML',
  FAILED_AML: 'Neuspešan AML',
  BLOCKED_AML: 'Blokiran AML',
  SUSPENDED_AML: 'Suspendovan AML',
  RISK_LIMIT_SET: 'Postavljanje risk limita',
  RISK_LIMIT_SET_FAILED: 'Neuspešno postavljanje risk limita',
  SENT: 'Poslata',
  SEND_FAILED: 'Neuspešno slanje',
  CHARGED: 'Naplaćena',
  CHARGE_FAILED: 'Neuspešna naplata',
  EVENT_PUBLISHED: 'Poslata',
  EVENT_PUBLISH_FAILED: 'Neuspešna',

  // Fraud protection

  howToProtectYourself: 'Kako da se zaštitite',
  pleaseBeAware: 'Prevare su moguće kada ne poznajete osobe kojima šaljete novac!',
  doNotSendMoney: 'Ne šaljite novac preko Western Uniona za:',
  doNotSendFirstPar:
    'kupovinu robe/usluga preko interneta – npr. automobila, uglavnom po mnogo povoljnijim cenama nego što su na tržištu;',
  doNotSendSecondPar: 'troškove koji prate dobijanje nekog nasledstva;',
  doNotSendThirdPar: 'učestvovanje u nagradnoj igri ili lutriji;',
  doNotSendFourPar: 'iznajmljivanje nekretnina;',
  doNotSendFivePar: 'realizovanje poslovne ponude;',
  doNotSendSixPar: 'troškove dobijanja vize za rad u inostranstvu;',
  doNotSendSevenPar:
    'putne troškove osobi koju ste upoznali preko društvenih mreža i sajtova za upoznavanje;',
  doNotSendEightPar:
    'pomoć prijatelju ili porodici na osnovu SMS-a ili i-mejla, u kojima se traži da se novac pošalje za hitan slučaj;',
  doNotSendNinePar:
    'realizovanje čeka koji je deponovan na vaše ime, a koji ne možete da odmah unovčite.',
  ourAdvice: 'Naši saveti:',
  ourAdviceFirstPar: 'Novac šaljite samo osobama koje poznajete i kojima verujete.',
  ourAdviceSecondPar:
    'Podaci o vašem transferu su poverljivi i ne treba da ih saopštavate drugim licima osim primaocu.',
  ourAdviceThirdPar:
    'Ne šaljite novac ukoliko niste u mogućnosti da prvo potvrdite identitet osobe koja vas je kontaktirala.',
  ourAdviceFourPar:
    'Ako ponuda zvuči suviše dobro da bi bila istinita, moguće je da je u pitanju prevara.',
  ourAdviceFivePar:
    'Novčani transfer se primaocu može isplatiti u veoma kratkom roku, a nakon što je novac isplaćen, ne možete dobiti povraćaj novca od Western Uniona, čak ni kada je reč o prevari.',
  ourAdviceSixPar:
    'Ne postoji način da isplatu odložite ako promenite ime i prezime primaoca ili zemlju odredišta nakon što ste novac poslali ili ako primaocu ne otkrijete kontrolni broj transfera novca (MTCN).',
  ourAdviceSevenPar:
    'Ukoliko želite da se informišete o usluzi Western Uniona ili ste novac poslali putem Western Uniona i mislite da ste žrtva prevare, pozovite Korisnički centar na broj 011/ 333 4 999.',
  ...srCommonTranslates,
  IdData: 'Podaci o identifikacionoj ispravi',
  ResidenceAddress: 'Adresa prebivališta/boravišta',
  Registration: 'Registracija',
  Other: 'Ostalo',
  RegistrationDescription:
    'Vaša email adresa i broj telefona su već registrovani. Molimo Vas da popunite sledeći obrazac kako bismo dopunili Vaš korisnički profil i omogućili dalji pristup aplikaciji.',
  Report_feedback: 'Report feedback',
};
